import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/mingxing-heiliao', label: '明星黑料' },
  { to: '/category/wanghong-bagua', label: '网红爆料' },
  { to: '/category/yulequan-neimu', label: '娱乐圈内幕' },
  { to: '/category/zongyi-jiemu', label: '综艺节目' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-foreground-100/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="text-xl md:text-2xl font-heading text-primary-500">
              黑料社
            </span>
            <span className="hidden md:inline text-xs text-foreground-500 bg-accent-100/80 px-2 py-0.5 rounded-full whitespace-nowrap">
              爆料聚合平台
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <nav className="md:hidden border-t border-foreground-100/40 py-3 pb-4 bg-background-50">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-3 py-2.5 text-sm rounded-lg transition-colors ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}